import '../../../ui/js/#app';
import './map-clusterer';
import mapStyle from '../../../ui/js/map-style.json';


/**
 * Account links
 */
$('body.account').each(function() {

	$('ul.LoginRegisterLinks').prepend('<li><a href="/sales/">Sales</a></li><li><a href="/developments/">Developments</a></li>');

});


/**
 * For map code to work
 */
String.prototype.escapeHTML = function () {

	return this.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");

};


/**
 * Map
 */
function initAFEMap() {

	var madrid = new google.maps.LatLng(40.416775, -3.703790); // Arbitrary location to get a map going

	map = new google.maps.Map($('main').find('div.grouped-map')[0], {

		center: madrid,
		zoom: 12,
		scrollwheel: false,
		styles: mapStyle

	});

	// Add the map when ready
	google.maps.event.addListenerOnce(map, 'idle', function() {

		updateAFEMap($('main').find('div.grouped-map').data('locations'));

	});

}

function afeGeoCallback(property) {

	if (property.title === '') {

		property.title = '-';

	}

	var geocodeCallBack = function(results, status) {

		// Set marker
		if (status == 'OK') {

			addAFEMapMarker(results[0].geometry.location, property);

		} else {

			// Record it as an increment
			checkAFEMapFinished();

		}

	}

	return geocodeCallBack;

}

function checkAFEMapFinished() {

	propertiesFound ++;

	if (propertiesFound == totalProperties) {

		var isFinished = true;

	} else {

		var isFinished = false;

	}

	// It's done so fit to bounds
	if (isFinished === true) {

		// Cluster markers if in listing
		if ($('body').hasClass('home') === true) {

			/*! Based on https://stackoverflow.com/a/37302915/2338825 by Tomasz Rozmus (https://stackoverflow.com/users/792026/tomasz-rozmus) */
			var getGoogleClusterInlineSvg = function (color) {

				var encoded = window.btoa('<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="-100 -100 200 200"><defs><g id="a" transform="rotate(45)"><path d="M0 47A47 47 0 0 0 47 0L62 0A62 62 0 0 1 0 62Z" fill-opacity="0.7"/><path d="M0 67A67 67 0 0 0 67 0L81 0A81 81 0 0 1 0 81Z" fill-opacity="0.5"/><path d="M0 86A86 86 0 0 0 86 0L100 0A100 100 0 0 1 0 100Z" fill-opacity="0.3"/></g></defs><g fill="' + color + '"><circle r="42"/><use xlink:href="#a"/><g transform="rotate(120)"><use xlink:href="#a"/></g><g transform="rotate(240)"><use xlink:href="#a"/></g></g></svg>');

				return ('data:image/svg+xml;base64,' + encoded);

			};

			var clusterStyles = [{

				width: 40,
				height: 40,
				url: getGoogleClusterInlineSvg('#ec5044'),
				textColor: 'white',
				textSize: 12

			}];

			var markerCluster = new window.MarkerClusterer(map, markers, {

				styles: clusterStyles

			});

		}

		resetAFEMap();

	}

}

function addAFEMapMarker(latLng, property) {

	var marker = new google.maps.Marker({

		map: map,
		position: latLng,
		icon: {

			url: '/assets/img/gui/marker.png',
			scaledSize: new google.maps.Size(64, 64)

		},
		title: property.title,
		id: property.id,
		//img: property.image

	});

	markers.push(marker);
	
	// Set marker to center when clicked
	google.maps.event.addListener(marker, 'click', function() {
		
		if (infowindow) {

			infowindow.close();

		}

		map.panTo(latLng);

		console.log(marker);

		infowindow = new google.maps.InfoWindow({

			content: '<div class="map-popup"><a href="' + 
			         $('body.home div.item[data-development-id="' + 
					 $.escapeSelector(marker.id) + 
					 '"]').find('a').eq(0).attr('href').escapeHTML() + 
					 '">' + 
					 marker.title.escapeHTML() + 
					 '<br /><br /><img src="' + 
					 $('body.home div.item[data-development-id="' + 
					 $.escapeSelector(marker.id) + '"]').eq(0).find('img').attr('src').escapeHTML() + 
					 '" alt="" /></a></div>'

		});

		infowindow.open(map, marker);

	});

	checkAFEMapFinished();

}

function updateAFEMap(locations) {

	removeAFEMarkers();

	isFinished = false;

	propertiesFound = 0;

	totalProperties = locations.length;

	for (var counter = 0; counter < locations.length; counter ++) {

		if (typeof locations[counter].latitude !== 'undefined' &&
		    typeof locations[counter].longitude !== 'undefined' &&
			locations[counter].latitude !== '' &&
			locations[counter].longitude !== '') {

			// Add but latitude and longitude
			addAFEMapMarker(new google.maps.LatLng(locations[counter].latitude, locations[counter].longitude), locations[counter]);

		} else {

			// Add by geocode
			geocoder.geocode({address: locations[counter].address }, afeGeoCallback(locations[counter]));

		}

	}

}

function resetAFEMap() {

	if (infowindow) {

		infowindow.close();

	}

	var bounds = new google.maps.LatLngBounds();

	for (var i = 0; i < markers.length; i++) {

		bounds.extend(markers[i].getPosition());

	}

	map.fitBounds(bounds);

	// Seems to zoom out too far sometimes
	if (map.getZoom() < 7) {

		map.setZoom(7);

	}

}

function removeAFEMarkers() {

	if (infowindow) {

		infowindow.close();

	}

	for (var i = 0; i < markers.length; i ++) {

		markers[i].setMap(null);

	}

	markers = [];

}


if ($('body').hasClass('home') === true) {

	// Set up map variables, objects
	var geocoder = new google.maps.Geocoder();
	var map;
	var infowindow;
	var markers = [];
	var propertiesFound = 0;
	var totalProperties = 0;
	var isFinished = false;

	google.maps.event.addDomListener(window, 'load', initAFEMap);

}


/**
 * Incremental items
 */
$('main').find('div.incremental-items')
         .each(function() {

	var $this = $(this);

	var $items = $this.find('div.item');

	// Hide all
	$items.hide();

	// Show first lot
	$items.slice(0, $this.data('num-to-show'))
	      .show();

	// Hide button if at the end already
	if ($items.length <= $this.data('num-to-show')) {

		$this.find('div.button')
		     .hide();

	}

	// Hide button if at the end
	if ($items.filter(':visible').length >= $this.data('total')) {

		$this.find('div.button')
		     .hide();

	}

	// Link handler
	$this.find('div.button a')
	     .on('click', function(e) {

		e.preventDefault();

		var index = $this.data('num-to-show') * $this.data('counter');

		$items.slice(index, (index + $this.data('num-to-show')))
		      .show();

		// Increment counter
		$this.data('counter', $this.data('counter') + 1);

		// Hide button if at the end
		if ($items.filter(':visible').length >= $this.data('total')) {

			$this.find('div.button')
			     .hide();

		}

	});

});